import React, { useEffect, useState } from "react";
import DropBtn from "../modules/DropBtn";
import Button from "../modules/Button";
import DropSelect from "../modules/AutoComplete";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import {
  addCandidateInfo,
  addCandidatePage,
  resetRegister,
} from "./redux/actions";
import sad from "../../Assets/svg/sad.svg";
import happy from "../../Assets/svg/happy.svg";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetTokens } from "../LoginPage/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { api } from "../../Services";
import { useNavigate } from 'react-router-dom';

function Source() {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const [sourceValue, setSourceValue] = useState("");
  const [course, setCourse] = useState("");
  const [type, setType] = useState("sad");

  const [list, setList] = useState([]);
  //   [
  //   { endDate: "2020-05-20T12:34:56.789", active: false, programType: "MBA" },
  //   {
  //     endDate: "2024-05-20T12:34:56.789",
  //     active: true,
  //     programType: "Engineering",
  //   },
  // ]);
  const registeredData = useSelector((state) => state.register.registeredData);
  const getSignup = () => {
    let url = GetBaseUrl(window.location.href);

    //     window.location.replace(url + "/signup/college");
    // if (type === "mobile") {
    // window.location.replace(url + "/signup/college")
    navigate("/signup/college");
    ;
    // }
  };
  const getSignin = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url);
    navigate('/');

  };
  const sadText = () => {
    return (
      <div className="sad-texts">
        <div className="sad-text">
          Only Full Time on Campus courses are eligible for the Program
        </div>
      </div>
    );
  };
  const nextPage = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/signup/college");
    navigate("/signup/college");

    // if (type === "regular") {
    //   if (registeredData?.info?.course.includes("MBA")) {

    //   } else {
    //     setType("sad");
    //   }
    // } else {
    //   let url = GetBaseUrl(window.location.href);
    //   window.location.replace(url);
    // }
  };
  const dispatchData = (type, e) => {
    dispatch(addCandidateInfo([type, e]));
    setCourse(e);
  };
  const getProgram = async () => {
    try {
      const prog = await api.program();
      console.log("callDoc", prog);
      return prog;
    } catch (error) {
      console.error("Error uploading Document:", error);
      // Handle error scenario
    }
  };
  const getProgs = async () => {
    try {
      let progList = await getProgram();
      console.log("progList", progList);
      for (let i = 0; i < progList?.data.length; i++) {
        if (
          progList.data[i]["programType"].toLowerCase().includes("engineering")
        ) {
          progList.data[i]["programType"] = capitalizeFirstLetter(
            progList?.data[i]["programType"]
          );
        }
      }
      setList([...progList?.data]);
    } catch (error) {
      console.error("Error uploading Document:", error);
      // Handle error scenario
    }
    // dispatch(addTokenInfo(["docs", docs2?.data]));
  };
  useEffect(() => {
    getProgs();
    setType("regular");

    window.onload = function () {
      window.localStorage.clear();
    };
    dispatch(addCandidateInfo(["source", ""]));
    dispatch(resetRegister());
    dispatch(resetState());
    dispatch(resetIncome());
    dispatch(resetEdu());
    dispatch(resetTokens());
    dispatch(resetApp());
    dispatch(resetQueries());
    dispatch(resetStatus());
  }, []);
  // useEffect(() => {
  //   // window.onload = function() {
  //     // window.localStorage.clear();
  //     window.localStorage.removeItem('persist:root');

  //   // };
  //   // window.localStorage.clear();
  // }, []);
  function capitalizeFirstLetter(str) {
    if (str?.includes("ENGINEERING")|| str?.includes("Engineering")) {
      return str
        .split(" ")
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
    } else {
      return str;
    }
  }
  return (
    <div
      className={`cred-section ${
        type !== "sad" && type !== "happy" && "source-section"
      } ${type}`}
    >
      {" "}
      {type === "sad" ? (
        <img className="sad" src={sad} alt="sad" />
      ) : type === "happy" ? (
        <img className="sad" src={happy} alt="happy" />
      ) : (
        ""
      )}
      {type === "sad" && (
        <span className="title">
          Sorry! The Engineering program is not available at the moment
        </span>
      )}
      {type === "regular" && (
        <>
          <span className="title">Sign Up</span>
          <span className="sub-title">
            To sign up, you first need to answer a few questions. Ready?
          </span>
          <div className="source-field">
            <DropBtn
              onChange={(e) =>
                dispatchData("course", capitalizeFirstLetter(e.programType))
              }
              // onChange={(e) => console.log("course", e.programType)}

              title={"Select the scholarship program"}
              value={registeredData?.info?.course}
              // list={["MBA", "Engineering"]}
              // list={list.filter((a)=>a.active === true)}
              list={list}
              // list={[{active:false, programType:"MBA"},{active:true, programType:"Engineering"}]}
            />
            {list.length === 0 && (
              <div className="set-sub-title" style={{ color: "red" }}>
                Sorry! Something went wrong, Please try again.
              </div>
            )}
          </div>
          <div className="source-field">
            <DropBtn
              onChange={(e) => dispatchData("source", e)}
              title={"Where did you hear about this program?"}
              value={registeredData?.info?.source}
              list={[
                "IDFC FIRST Bank Website",
                "Buddy4Study",
                "My College",
                "Social Media",
                "Word of Mouth",
                "Internet",
                "Others",
              ]}
            />
          </div>
        </>
      )}
      <div className="cred-btn">
        <Button
          disabled={
            type === "regular" &&
            (registeredData?.info?.source === "" ||
              registeredData?.info?.course === "")
          }
          onClickHandler={() => nextPage()}
          value={type === "sad" ? "Back to Home" : "Get started"}
          type={"contained"}
        />
        {type === "regular" && (
          <div className="text-btn">
            <Button
              onClickHandler={() => getSignin()}
              value={"Already Registered? Sign In"}
              type={"only-text"}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Source;
